import {Controller, useFormContext} from 'react-hook-form';
import {Validators} from '@chekin/api';
import {PhoneInput as PhoneInputComponent} from '../ui/PhoneInput';
import {FormFieldWrapper} from '../ui/FormFieldWrapper';

type PhoneInputProps = {
  name: string;
  label: string;
};

const PhoneInput = ({name, label}: PhoneInputProps) => {
  const {control} = useFormContext();

  return (
    <FormFieldWrapper className="!w-full">
      <Controller
        name={name}
        rules={{validate: {valid: Validators.phoneValidateService}}}
        control={control}
        render={({field, fieldState: {error}}) => (
          <PhoneInputComponent
            label={label}
            error={error?.message}
            className="max-w-full"
            {...field}
          />
        )}
      />
    </FormFieldWrapper>
  );
};

export {PhoneInput};
